<div class="pod-search-result">
    <div class="pod-column rejected-icon">
        <i class="fa fa-times errorIndicator" [hidden]="!podValidation.rejected"></i>
        <i class="fa fa-file"
           [hidden]="!podValidation.rejected"
           [i18n]="[{target: 'attribute:title', key: 'pods-validation.tabs.item.rejected', params: { reason: podValidation.rejectReason ? (':\n' + podValidation.rejectReason) : '' }}]">
        </i>
    </div>
    <div class="pod-column delivery-information">
        <div>
            <span class="delivery-information-id">
                <a class="badge badge-link badge-size-md cmaweb-link" [href]="link.goToLoadManagementForLoad(podValidation.loadNumber)" target="_blank">{{podValidation.loadNumber}}</a>&nbsp;
                <a class="cmaweb-link" [href]="link.goToLoadManagementForDelivery(podValidation.deliveryNumber)" target="_blank"
                   [popover]="salesOrderPopTemplate" placement="top" container="body" triggers="mouseenter:mouseleave">
                    {{podValidation.deliveryNumber}}</a>
            </span>
            <ng-template #salesOrderPopTemplate>
                <chp-delivery-and-sales-order-numbers
                    [deliveryNumbers]="[podValidation.deliveryNumber]"
                    [salesOrderNumbers]="[podValidation.salesOrderNumber]">
                </chp-delivery-and-sales-order-numbers>
            </ng-template>
        </div>
        <div>
            <span>
                <span class="delivery-type" [i18n]="'pods-validation.tabs.item.type.'+podValidation.type.toLowerCase()"></span>
                <span *ngIf="podValidation.type === PodValidationTypes.MANUFACTURER">: {{podValidation.originName}}&nbsp;
                    (<span class="origin-glid" (click)="appendOriginGlidInFilter(podValidation.originGlid)">{{podValidation.originGlid}}</span>)
                </span>
            </span>
        </div>
        <div *ngIf="podValidation.type === PodValidationTypes.MR">
            <span>
                <span [i18n]="'pods-validation.tabs.item.origin'"></span>: {{podValidation.originName}}&nbsp;
                (<span class="origin-glid" (click)="appendOriginGlidInFilter(podValidation.originGlid)">{{podValidation.originGlid}}</span>)
            </span>
        </div>
        <div>
            <span>
                <span [i18n]="'pods-validation.tabs.item.destination'"></span>: {{podValidation.destinationName}}&nbsp;
                (<span class="destination-glid" (click)="appendDestinationGlidInFilter(podValidation.destinationGlid)">{{podValidation.destinationGlid}}</span>)
            </span>
        </div>
        <div>
            <span [i18n]="[{target: 'innerHTML', key: 'pods-validation.tabs.item.planned-delivery', params: { date: (podValidation.deliveryDate | fullDate:false) }}]"></span>
        </div>
        <div *ngIf="isPodManager">
            <span [i18n]="'pods-validation.tabs.item.carrier-new'"></span>
            <a class="cmaweb-link" [href]="link.goToCarrierName(podValidation.carrierName, !isPodManager)" target="_blank">{{podValidation.carrierName}}</a>
        </div>
    </div>
    <div class="pod-column left-section">
        <div class="actions" *ngIf="displayUploadActions()">
            <app-file-upload *ngIf="!fileToUpload"
                             [acceptedFileExtensions]="acceptedFileExtensions"
                             [acceptedFileTypes]="acceptedFileTypes"
                             [labelKey]="'pods-validation.document.upload.input-label'"
                             [id]="podValidation.id"
                             (onFileAdded)="fileToUpload = $event">
            </app-file-upload>
        </div>

        <span class="pod-row" *ngIf="podValidation.submissionDate != null">
            <span [i18n]="[{target: 'innerHTML', key: 'pods-validation.tabs.item.submission-date', params: { date: (podValidation.submissionDate | fullDate:false) }}]"></span>
            <app-pods-validation-document-source [source]="podValidation.documentSource"></app-pods-validation-document-source>
        </span>

        <div class="pod-column" *ngIf="displayUploadActions() && fileToUpload">
            <span [i18n]="'pods-validation.tabs.item.upload.confirmation'"></span><br/>
            <div class="pod-row actions">
                <button class="btn btn-i btn-danger btn-sm" [disabled]="isWorking" (click)="fileToUpload = null">
                    <span [i18n]="'pods-validation.tabs.item.actions.cancel'"></span>
                </button>
                <button class="btn btn-i btn-success btn-sm" [disabled]="isWorking" (click)="uploadPodFile(fileToUpload, mrFinalQuantityModal)">
                    <i class="fas fa-check"></i>
                    <span [i18n]="'pods-validation.tabs.item.actions.confirm'"></span>
                </button>
            </div>
        </div>

        <div class="pod-row display-pod" *ngIf="displaySeeButton()">
            <button class="btn btn-i btn-primary btn-sm"
                    (click)="onPodClicked.emit()">
                <i class="fa fa-eye"></i>
                <span [i18n]="'pods-validation.tabs.item.actions.see-pod'"></span>
            </button>
        </div>

        <div class="pod-row actions" *ngIf="displayPodManagerActions()">
            <button class="btn btn-i btn-danger btn-sm" [disabled]="isWorking" (click)="rejectPod(podValidation, deleteOptionModal)">
                <i class="fas fa-times"></i>
                <span [i18n]="'pods-validation.tabs.item.actions.reject'"></span>
            </button>
            <button class="btn btn-i btn-success btn-sm" [disabled]="isWorking" (click)="validatePod(podValidation)">
                <i class="fas fa-check"></i>
                <span [i18n]="'pods-validation.tabs.item.actions.validate'"></span>
            </button>
        </div>
    </div>
</div>

<ng-template #deleteOptionModal let-c="close" let-d="dismiss">
    <div class="delete-option-modal">
        <p [i18n]="'pods-validation.reject.content'"></p>
        <textarea [(ngModel)]="rejectReason"
                  name="rejectReason"
                  rows="3"
                  maxlength="300"
                  [i18n]="[{target: 'attribute:placeholder', key: 'pods-validation.reject.input-placeholder'}]">
        </textarea>
        <span>(</span>{{rejectReason ? rejectReason.length : 0}}<span>/300)</span>
    </div>
</ng-template>

<ng-template #mrFinalQuantityModal>
    <div class="mr-final-quantity-modal">
        <label class="control-label" [i18n]="'pods-validation.upload.mr-final-quantity.content'"></label>&nbsp;
        <input type="number" [(ngModel)]="podValidation.mrFinalQuantity" [min]="0" (keydown)="onNumberInputKeydown($event)">
    </div>
</ng-template>
